/* ============================================================================
   OIYK Complete-the-Look — shared recommendation engine
   Powers BOTH the product page ("You may also like") and the cart drawer
   ("Complete the look" + free-shipping bar). Rule-based, KISS.

   Logic:
     anchor = the product being viewed (PDP) OR the first item added (cart)
     rotation:  necklace -> earrings -> bracelet
                earrings -> necklace -> bracelet
                bracelet -> necklace -> earrings
     match tiers within the target category:
       1) same subcategory   (baroque necklace -> baroque earrings)
       2) same family        (any pearl earring)
       3) sensible complement (colorful -> neutral gold hoops; metal -> pearl
                               bracelet; scarf -> pearl drops) — a nudge, not a
                               forced "set" (per Dan).
   Live product data (price/image/variant/availability) is fetched from Shopify
   at runtime, so prices update automatically once retail prices are set.
   ========================================================================== */
(function () {
  'use strict';

  var THRESHOLD = 20000; // free-shipping threshold in cents ($200)

  /* ---- the map: 6-char SKU code -> {handle, cat, fam, sub} -----------------
     cat: n=necklace e=earring b=bracelet
     fam: pearl | sculpted | beads | scarf
     sub: baroque | mop | round | pearlgem | hoops | florals | chunky | rainbow | shellseed | charm | scarf */
  var P = {
    OYN0001:{h:'oyn0001',cat:'n',fam:'pearl',sub:'mop'},
    OYN0002:{h:'oyn0002',cat:'n',fam:'pearl',sub:'mop'},
    OYN0003:{h:'oyn0003',cat:'n',fam:'pearl',sub:'mop'},
    OYN0024:{h:'freshwater-shell-flower-pendant-gold-chain-necklace',cat:'n',fam:'pearl',sub:'mop'},
    OYN0025:{h:'freshwater-shell-flower-pendant-staggered-freshwater-pearl-choker',cat:'n',fam:'pearl',sub:'mop'},
    OYN0008:{h:'oyn0008',cat:'n',fam:'pearl',sub:'round'},
    OYN0016:{h:'freshwater-pearl-beaded-necklace',cat:'n',fam:'pearl',sub:'round'},
    OYN0017:{h:'pearl-bead-necklace-with-mother-of-pearl-charms',cat:'n',fam:'pearl',sub:'round'},
    OYN0018:{h:'pearl-cross-pendant-necklace',cat:'n',fam:'pearl',sub:'round'},
    OYN0010:{h:'oyn0010',cat:'n',fam:'pearl',sub:'baroque'},
    OYN0011:{h:'oyn0011',cat:'n',fam:'pearl',sub:'baroque'},
    OYN0012:{h:'oyn0012',cat:'n',fam:'pearl',sub:'baroque'},
    OYN0026:{h:'layered-baroque-pearl-necklace',cat:'n',fam:'pearl',sub:'baroque'},
    OYN0006:{h:'oyn0006',cat:'n',fam:'pearl',sub:'pearlgem'},
    OYN0029:{h:'freshwater-pearl-with-shell-fish-charm-and-multicolor-gemstones-necklace',cat:'n',fam:'pearl',sub:'pearlgem'},
    OYN0004:{h:'oyn0004',cat:'n',fam:'beads',sub:'chunky'},
    OYN0007:{h:'oyn0007',cat:'n',fam:'beads',sub:'chunky'},
    OYN0009:{h:'oyn0009',cat:'n',fam:'beads',sub:'chunky'},
    OYN0019:{h:'barrel-cut-stone-bead-necklace',cat:'n',fam:'beads',sub:'chunky'},
    OYN0005:{h:'oyn0005',cat:'n',fam:'beads',sub:'rainbow'},
    OYN0027:{h:'multicolor-bead-and-stone-necklace',cat:'n',fam:'beads',sub:'rainbow'},
    OYN0030:{h:'shell-fish-shaped-beads-with-tri-color-gemstones-necklace',cat:'n',fam:'beads',sub:'shellseed'},
    OYN0031:{h:'star-and-heart-shell-with-seed-beads-necklace',cat:'n',fam:'beads',sub:'shellseed'},
    OYN0013:{h:'round-pendant-chain-necklace',cat:'n',fam:'sculpted',sub:'florals'},
    OYN0014:{h:'lucite-flower-pendant-cord-necklace',cat:'n',fam:'sculpted',sub:'florals'},
    OYN0028:{h:'sculpted-flower-collar-necklace',cat:'n',fam:'sculpted',sub:'florals'},
    OYN0021:{h:'multicolor-charm-necklace',cat:'n',fam:'sculpted',sub:'charm'},
    OYN0022:{h:'hammered-gold-link-necklace',cat:'n',fam:'sculpted',sub:'hoops'},
    OYN0023:{h:'long-hammered-gold-link-necklace',cat:'n',fam:'sculpted',sub:'hoops'},
    OYN0032:{h:'layered-gold-chain-necklace',cat:'n',fam:'sculpted',sub:'hoops'},
    OYN0015:{h:'silk-scarf-wrapped-baroque-pearl-necklace',cat:'n',fam:'scarf',sub:'scarf'},
    OYE0001:{h:'oye0001',cat:'e',fam:'pearl',sub:'mop'},
    OYE0009:{h:'mother-of-pearl-cross-drop-earrings',cat:'e',fam:'pearl',sub:'mop'},
    OYE0015:{h:'sculpted-flower-drop-earrings',cat:'e',fam:'pearl',sub:'mop'},
    OYE0002:{h:'textured-disc-and-baroque-pearl-drop-earrings',cat:'e',fam:'pearl',sub:'baroque'},
    OYE0006:{h:'swirl-knot-and-baroque-pearl-drop-earrings',cat:'e',fam:'pearl',sub:'baroque'},
    OYE0012:{h:'gold-flower-and-baroque-pearl-drop-earrings',cat:'e',fam:'pearl',sub:'baroque'},
    OYE0003:{h:'hammered-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0004:{h:'dome-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0007:{h:'engraved-crescent-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0010:{h:'silver-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0013:{h:'sculpted-feather-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0019:{h:'crescent-shell-hoop-earrings-small',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0008:{h:'chunky-resin-hoop-earrings',cat:'e',fam:'sculpted',sub:'hoops'},
    OYE0005:{h:'textured-fan-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0011:{h:'sculpted-drop-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0014:{h:'abstract-flower-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0016:{h:'sculpted-orchid-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0017:{h:'flower-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0018:{h:'sculpted-flower-drop-earrings-1',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0020:{h:'crystal-bloom-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0021:{h:'crystal-stone-flower-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0022:{h:'petite-crystal-flower-stud-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYE0023:{h:'cascading-flower-drop-earrings',cat:'e',fam:'sculpted',sub:'florals'},
    OYB0001:{h:'freshwater-pearl-with-shell-fish-charm-and-multicolor-gemstones-bracelet',cat:'b',fam:'pearl',sub:'pearlgem'},
    OYB0003:{h:'freshwater-pearl-and-multicolor-gemstones-bracelet',cat:'b',fam:'pearl',sub:'pearlgem'},
    OYB0002:{h:'star-and-heart-shell-with-seed-beads-bracelet',cat:'b',fam:'beads',sub:'shellseed'}
  };
  // handle -> code (reverse lookup for the PDP anchor)
  var BY_HANDLE = {}; for (var k in P) { BY_HANDLE[P[k].h] = k; }
  var LIST = Object.keys(P).map(function (c) { var o = P[c]; return {code:c,h:o.h,cat:o.cat,fam:o.fam,sub:o.sub}; });

  var ROTATION = { n:['e','b'], e:['n','b'], b:['n','e'] };
  // neutral gold hoops used when a colorful piece has no in-family earring
  var NEUTRAL_HOOPS = ['OYE0003','OYE0004','OYE0010','OYE0007'];
  // beads necklaces (multicolor / chunky) have no bead earring; lead with the
  // bold chunky resin hoops, then fall back to neutral gold hoops.
  var BEADS_HOOPS   = ['OYE0008','OYE0003','OYE0004','OYE0010','OYE0007'];
  var PEARL_DROPS   = ['OYE0001','OYE0012','OYE0002','OYE0009'];
  var PEARL_BRACELET= ['OYB0003','OYB0001'];

  /* rank candidates of a target category for an anchor, best first */
  function rankCandidates(anchor, targetCat, excludeCodes) {
    var ex = {}; (excludeCodes||[]).forEach(function (c){ ex[c]=1; });
    var pool = LIST.filter(function (p){ return p.cat===targetCat && !ex[p.code]; });
    var inFam = pool.filter(function (p){ return p.fam===anchor.fam; });
    var subMatch = inFam.filter(function (p){ return p.sub===anchor.sub; });
    if (subMatch.length) return subMatch.concat(inFam.filter(function(p){return p.sub!==anchor.sub;}));
    if (inFam.length)  return inFam;
    // Tier 3 — sensible complement (a nudge, not a forced set)
    var fb = [];
    if (targetCat==='e') {
      // scarf -> pearl drops; beads (multicolor/chunky) -> chunky resin hoops first; else neutral hoops
      fb = (anchor.fam==='scarf') ? PEARL_DROPS : (anchor.fam==='beads') ? BEADS_HOOPS : NEUTRAL_HOOPS;
    } else if (targetCat==='b') {
      fb = PEARL_BRACELET; // metal/scarf -> soften with a pearl bracelet
    }
    return fb.map(function (c){ return P[c] ? {code:c,h:P[c].h,cat:P[c].cat,fam:P[c].fam,sub:P[c].sub} : null; })
             .filter(Boolean).filter(function (p){ return !ex[p.code]; });
  }

  /* pick recommendations for an anchor. count=1 for cart, more for PDP.
     have = categories already present (cart items); exclude = codes to skip */
  function recommend(anchorCode, opts) {
    opts = opts || {};
    var anchor = LIST.filter(function (p){ return p.code===anchorCode; })[0];
    if (!anchor) return [];
    var order = ROTATION[anchor.cat];
    var have = opts.have || {};
    var exclude = (opts.exclude || []).slice(); exclude.push(anchorCode);
    var want = opts.count || 1;
    var out = [];
    for (var i=0; i<order.length && out.length<want; i++) {
      var tc = order[i];
      if (have[tc]) continue;                       // already in the cart
      var ranked = rankCandidates(anchor, tc, exclude.concat(out.map(function(p){return p.code;})));
      for (var j=0; j<ranked.length && out.length<want; j++) { out.push(ranked[j]); }
    }
    return out;
  }

  /* ---- live product data (price/image/variant/available) ------------------ */
  var CACHE = {};
  function fetchProduct(handle) {
    if (CACHE[handle]) return CACHE[handle];
    CACHE[handle] = fetch('/products/' + handle + '.js', {headers:{'Accept':'application/json'}})
      .then(function (r){ return r.ok ? r.json() : null; })
      .then(function (pj){
        if (!pj) return null;
        var v = (pj.variants||[]).filter(function(x){return x.available;})[0] || pj.variants[0] || {};
        return { handle:handle, title:pj.title, url:'/products/'+handle,
                 img:(pj.featured_image||(pj.images&&pj.images[0])||''),
                 price:v.price!=null?v.price:pj.price, variantId:v.id, available:!!v.available };
      })
      .catch(function(){ return null; });
    return CACHE[handle];
  }
  function money(cents) {
    var s = '$' + (Number(cents||0)/100).toFixed(2);
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace('$,', '$');
  }

  /* ========================= PRODUCT PAGE ================================== */
  function initPDP() {
    var mount = document.getElementById('oiyk-reco-pdp');
    if (!mount) return;
    var handle = mount.getAttribute('data-handle');
    var code = BY_HANDLE[handle];
    if (!code) { mount.style.display='none'; return; }   // not an OIYK piece
    var recs = recommend(code, {count:4});
    if (!recs.length) { mount.style.display='none'; return; }
    Promise.all(recs.map(function(r){ return fetchProduct(r.h); })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length){ mount.style.display='none'; return; }
      var cards = items.map(function (p){
        var im = p.img ? '<img src="'+p.img+'&width=500" loading="lazy" alt="">' : '';
        return '<a class="oiyk-rc" href="'+p.url+'"><span class="oiyk-rc-img">'+im+'</span>'+
          '<span class="oiyk-rc-title">'+p.title+'</span>'+
          '<span class="oiyk-rc-price">'+money(p.price)+'</span></a>';
      }).join('');
      mount.innerHTML = '<div class="oiyk-related"><h2 class="oiyk-related-h">Complete the look</h2>'+
        '<div class="oiyk-related-grid">'+cards+'</div></div>';
    });
  }

  /* ========================= CART DRAWER ================================== */
  function anchorFromCart(cart) {
    // first line item that is an OIYK piece = the anchor
    var items = cart.items || [];
    for (var i=0;i<items.length;i++){
      var code = codeFromItem(items[i]);
      if (code) return {code:code, items:items};
    }
    return null;
  }
  function codeFromItem(it) {
    var sku = (it.sku||'').toUpperCase();
    var m = sku.match(/OY[NEB]\d{4}/); if (m && P[m[0]]) return m[0];
    var h = (it.handle||''); if (BY_HANDLE[h]) return BY_HANDLE[h];
    return null;
  }
  function haveCats(cart) {
    var have = {};
    (cart.items||[]).forEach(function (it){ var c=codeFromItem(it); if(c) have[P[c].cat]=1; });
    return have;
  }
  function excludeCodes(cart) {
    var ex = [];
    (cart.items||[]).forEach(function (it){ var c=codeFromItem(it); if(c) ex.push(c); });
    return ex;
  }

  function ensureCartMount() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer) return null;
    var box = document.getElementById('oiyk-cart-reco');
    if (!box) {
      box = document.createElement('div');
      box.id = 'oiyk-cart-reco';
      footer.insertBefore(box, footer.firstChild);   // top of the footer, persists across item re-renders
    }
    return box;
  }

  // Signature of the cart's contents — used to skip needless re-renders. The
  // cart drawer mutates constantly (open/close classes, Dawn re-renders); if we
  // rebuilt the carousel on every mutation we'd reset its scroll position, so
  // the prev/next arrows would appear dead. Only rebuild when this changes.
  var LAST_SIG = null;
  function cartSig(cart) {
    return (cart.item_count || 0) + '|' + (cart.total_price || 0) + '|' +
      (cart.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join(',');
  }

  function renderShipBar(subtotal) {
    if (subtotal >= THRESHOLD) {
      return '<div class="oiyk-ship win"><p class="oiyk-ship-msg">Free shipping unlocked ✓</p>'+
             '<div class="oiyk-track"><div class="oiyk-fill win" style="width:100%"></div></div></div>';
    }
    var gap = THRESHOLD - subtotal;
    var pct = subtotal===0 ? 0 : Math.min(100, Math.round(subtotal/THRESHOLD*100));
    var msg = subtotal===0 ? 'Free standard shipping on orders over $200.'
                           : 'You’re <b>'+money(gap)+'</b> away from free shipping.';
    return '<div class="oiyk-ship"><p class="oiyk-ship-msg">'+msg+'</p>'+
           '<div class="oiyk-track"><div class="oiyk-fill" style="width:'+pct+'%"></div></div></div>';
  }

  function cartCard(p) {
    var im = p.img ? '<img src="'+p.img+'&width=200" alt="" loading="lazy">' : '';
    return '<div class="oiyk-cl-card">'+
        '<span class="oiyk-cl-img">'+im+'</span>'+
        '<div class="oiyk-cl-info">'+
          '<div class="oiyk-cl-nm">'+p.title+'</div>'+
          '<div class="oiyk-cl-pr">'+money(p.price)+'</div>'+
          '<button type="button" class="oiyk-cl-add" data-vid="'+p.variantId+'">Add to cart</button>'+
        '</div>'+
      '</div>';
  }

  function renderCart() {
    var box = ensureCartMount();
    if (!box) return;
    fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function (cart) {
      // Skip if nothing changed AND we've already rendered — preserves the
      // carousel's scroll position so the prev/next arrows keep working.
      var sig = cartSig(cart);
      if (sig === LAST_SIG && box.firstChild) return;
      LAST_SIG = sig;
      var subtotal = cart.total_price || 0;
      var ship = renderShipBar(subtotal);
      var anchor = anchorFromCart(cart);
      if (!anchor) { box.innerHTML = ship; return; }
      var recs = recommend(anchor.code, {count:6, have:haveCats(cart), exclude:excludeCodes(cart)});
      if (!recs.length) { box.innerHTML = ship; return; }
      Promise.all(recs.map(function(r){ return fetchProduct(r.h); })).then(function (items) {
        items = items.filter(function(p){ return p && p.variantId; });
        if (!items.length) { box.innerHTML = ship; return; }
        var cards = items.map(cartCard).join('');
        var multi = items.length > 1;
        box.innerHTML =
          '<div class="oiyk-cl">'+
            '<div class="oiyk-cl-h">Complete the look</div>'+
            '<div class="oiyk-cl-car'+(multi?' has-nav':'')+'">'+
              (multi?'<button type="button" class="oiyk-cl-nav prev" aria-label="Previous">&#8249;</button>':'')+
              '<div class="oiyk-cl-track">'+cards+'</div>'+
              (multi?'<button type="button" class="oiyk-cl-nav next" aria-label="Next">&#8250;</button>':'')+
            '</div>'+
          '</div>' + ship;
        var addBtns = box.querySelectorAll('.oiyk-cl-add');
        for (var i=0;i<addBtns.length;i++){ (function(btn){
          btn.addEventListener('click', function(){ addToCart(btn.getAttribute('data-vid'), btn); });
        })(addBtns[i]); }
        var track = box.querySelector('.oiyk-cl-track');
        var prev = box.querySelector('.oiyk-cl-nav.prev');
        var next = box.querySelector('.oiyk-cl-nav.next');
        function step(){ var c = track && track.querySelector('.oiyk-cl-card'); return c ? c.getBoundingClientRect().width + 12 : 200; }
        if (prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
        if (next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
      });
    }).catch(function(){});
  }

  function addToCart(variantId, btn) {
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled=true; btn.textContent='Adding…'; }
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/javascript'},
      body: JSON.stringify({ items:[{id:variantId, quantity:1}], sections:'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function(r){ return r.json(); }).then(function (state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      else renderCart();
      if (drawer && typeof drawer.open === 'function') drawer.open();
      setTimeout(renderCart, 60);
    }).catch(function(){ if(btn){btn.disabled=false;btn.textContent=orig||'Add to cart';} });
  }

  function watchCart() {
    var target = document.querySelector('cart-drawer');
    if (!target) return;
    // re-render whenever Dawn rewrites the cart items (add/remove/qty) or opens
    // the drawer — debounced so drawer animations don't spam /cart.js. The
    // signature check in renderCart() makes redundant calls cheap no-ops.
    var t = null;
    var mo = new MutationObserver(function(){
      if (t) return;
      t = setTimeout(function(){ t = null; renderCart(); }, 120);
    });
    mo.observe(target, {subtree:true, childList:true, attributes:true, attributeFilter:['class']});
    renderCart();
  }

  function boot(){ initPDP(); watchCart(); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
